import React from "react";
import { Table } from "react-bootstrap";
import MembersDocument from "./MembersDocument";
import ApplicationOverview from "./ApplicationOverview";
import ApplicationList from "./ApplicationList";
import * as ROUTES from "../Constants/Routes";
import AppConstants from "../Constants/AppConstants";
import {
  S_APPLICANT_ID,
  S_CURRENT_MEMBER_IN_MARKETPLACE,
} from "../Communication/Constants";

export default function MembersApplication({
  memberApplicationsTab,
  setMemberApplicationsTab,
  selectedMember,
  portfolioSubTab,
  setPortfolioSubTab,
  doFileList,
  doUploadFile,
  applicationList,
  productVault,
  productList,
  proceedWithApplication,
  switchBanking,
  history,
  targetApplicationId,
  doDeleteApplication,
  doUpdateProductToVault,
  refreshMemberDetails,
  doAddDocument,
  doDeleteDocument,
  doGetDocumentList,
  doGetDocument,
  doGetApplicationProperty,
  applicant,
  employmentAndIncomeReducer,
  complianceReducer,
  doGetProductInformation,
  finInfo,
  doGetApplicationNotes,
  doUpdateApplicationNotesReview,
  doConfirmApp,
  doGetProductFromVault,
  doGetVault,
  handleBreadcrumbBackToApplications,
  updateUrlParams,
  setShowMemberDetails,
}) {
  const handleMemberMarketplace = () => {
    switchBanking(AppConstants.BANKING_TYPE.PERSONAL);
    sessionStorage.removeItem(S_APPLICANT_ID);
    // Navigate to dashboard with marketplace parameter
    sessionStorage.setItem(S_CURRENT_MEMBER_IN_MARKETPLACE, "true");
    history.push(ROUTES.VAULT_DASHBOARD + "?marketplace");
  };

  const renderApplicationOverview = () => (
    <ApplicationOverview selectedMember={selectedMember} />
  );

  // Member banking profile applications tab bar component
  const memberApplicationsTabBar = (
    <div className="[ branch-tab-container ]">
      <ul className="[ nav nav-tabs w-100 d-flex ]">
        <li className="[ nav-item flex-fill text-center ]" key={"overview"}>
          <button
            type="button"
            className={
              memberApplicationsTab === "overview"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"overview"}
            onClick={() => setMemberApplicationsTab("overview")}
          >
            Overview
          </button>
          <div
            className={
              memberApplicationsTab === "overview" ? "[ tab-line ]" : ""
            }
          ></div>
        </li>
        <li className="[ nav-item flex-fill text-center ]" key={"documents"}>
          <button
            type="button"
            className={
              memberApplicationsTab === "documents"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"documents"}
            onClick={() => setMemberApplicationsTab("documents")}
          >
            Documents
          </button>
          <div
            className={
              memberApplicationsTab === "documents" ? "[ tab-line ]" : ""
            }
          ></div>
        </li>
        <li className="[ nav-item flex-fill text-center ]" key={"portfolio"}>
          <button
            type="button"
            className={
              memberApplicationsTab === "portfolio"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"portfolio"}
            onClick={() => setMemberApplicationsTab("portfolio")}
          >
            {memberApplicationsTab === "portfolio" ? "Portfolio" : "Portfolio"}
          </button>
          <div
            className={
              memberApplicationsTab === "portfolio" ? "[ tab-line ]" : ""
            }
          ></div>
        </li>
        <li className="[ nav-item flex-fill text-center ]" key={"applications"}>
          <button
            type="button"
            className={
              memberApplicationsTab === "applications"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"applications"}
            onClick={() => setMemberApplicationsTab("applications")}
          >
            Applications
          </button>
          <div
            className={
              memberApplicationsTab === "applications" ? "[ tab-line ]" : ""
            }
          ></div>
        </li>
        <li className="[ nav-item flex-fill text-center ]" key={"notes"}>
          <button
            type="button"
            className={
              memberApplicationsTab === "notes"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"notes"}
            onClick={() => setMemberApplicationsTab("notes")}
          >
            Notes
          </button>
          <div
            className={memberApplicationsTab === "notes" ? "[ tab-line ]" : ""}
          ></div>
        </li>
        <li
          className="[ nav-item flex-fill text-center ]"
          key={"client-growth"}
        >
          <button
            type="button"
            className={
              memberApplicationsTab === "client-growth"
                ? "[ form-subtitle nav-link active ]"
                : "[ form-subtitle nav-link inactive ]"
            }
            data-toggle="tab"
            role="tab"
            aria-controls={"client-growth"}
            onClick={() => setMemberApplicationsTab("client-growth")}
          >
            Client&nbsp;Growth&nbsp;Potential
          </button>
          <div
            className={
              memberApplicationsTab === "client-growth" ? "[ tab-line ]" : ""
            }
          ></div>
        </li>
      </ul>
    </div>
  );

  return (
    <div
      className="branch-recent-member p-3"
      style={{
        borderRight: "1px solid #eee",
        borderLeft: "1px solid #eee",
        background: "#fff",
        borderRadius: "0.5rem",
        minHeight: "100vh",
      }}
    >
      {/* Tab selection */}
      {memberApplicationsTabBar}

      {/* Tab Content */}
      {memberApplicationsTab === "overview" && renderApplicationOverview()}

      {memberApplicationsTab === "documents" && (
        <MembersDocument
          selectedMember={selectedMember}
          doFileList={doFileList}
          doUploadFile={doUploadFile}
        />
      )}

      {memberApplicationsTab === "portfolio" && (
        <div>
          {/* Portfolio Tab Bar using personalTabBar pattern */}
          <div className="branch-subtab-container">
            <div className="tab-wrapper">
              <ul className="nav nav-tabs">
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      portfolioSubTab === "accounts"
                        ? "nav-link active"
                        : "nav-link inactive"
                    }
                    onClick={() => setPortfolioSubTab("accounts")}
                  >
                    Member Accounts
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      portfolioSubTab === "assets"
                        ? "nav-link active"
                        : "nav-link inactive"
                    }
                    onClick={() => setPortfolioSubTab("assets")}
                  >
                    Assets{" "}
                    <span style={{ color: "#28a745", fontWeight: "bold" }}>
                      250,789.00
                    </span>
                  </button>
                </li>
                <li className="nav-item">
                  <button
                    type="button"
                    className={
                      portfolioSubTab === "liabilities"
                        ? "nav-link active"
                        : "nav-link inactive"
                    }
                    onClick={() => setPortfolioSubTab("liabilities")}
                  >
                    Liabilities{" "}
                    <span style={{ color: "#dc3545", fontWeight: "bold" }}>
                      5,789.00
                    </span>
                  </button>
                </li>
              </ul>
            </div>
            <div className="bottom-border"></div>
          </div>

          {/* Conditional Content Based on Selected Sub-Tab */}
          {portfolioSubTab === "accounts" && (
            <>
              {/* Member ID Filter Buttons */}
              <div className="mb-3 d-flex gap-3 flex-wrap">
                <button
                  className="btn btn-dark"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    minWidth: "60px",
                  }}
                >
                  All
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Member ID: 590398392
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Member ID: 590399876
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Member ID: 590391211
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Member ID: 590390000
                </button>
              </div>

              {/* Member Accounts Table */}
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  hover
                  size="sm"
                  style={{ fontSize: 12, minWidth: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>
                        CATEGORY{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>PRODUCT NAME</th>
                      <th>ACCT. #</th>
                      <th>NICKNAME</th>
                      <th>
                        MEMBER ID #{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>BALANCE</th>
                      <th>QUICK VIEW</th>
                      <th>
                        <i className="fas fa-external-link-alt" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Chequing</td>
                      <td>All-Inclusive Chequing</td>
                      <td>100011303919</td>
                      <td>AJAY-CHQ</td>
                      <td>M-590398392</td>
                      <td className="text-end fw-bold text-danger">
                        $ -1,298.54
                      </td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                      <td>
                        <i className="fas fa-external-link-alt fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Chequing</td>
                      <td>Chequing - 101</td>
                      <td>100011303922</td>
                      <td>AJAY-CHQ-101</td>
                      <td>M-590398392</td>
                      <td className="text-end fw-bold text-success">
                        $ 3,590.68
                      </td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                      <td>
                        <i className="fas fa-external-link-alt fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Savings</td>
                      <td>High Interest Savings</td>
                      <td>100011304001</td>
                      <td>AJAY-SAV</td>
                      <td>M-590399876</td>
                      <td className="text-end fw-bold text-success">
                        $ 38,290.18
                      </td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                      <td>
                        <i className="fas fa-external-link-alt fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Savings</td>
                      <td>High Interest Savings</td>
                      <td>100011304002</td>
                      <td>AJAY-MON-SAV</td>
                      <td>M-590391211</td>
                      <td className="text-end fw-bold text-success">
                        $ 118,987.00
                      </td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                      <td>
                        <i className="fas fa-external-link-alt fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Member Shares</td>
                      <td>Member Shares</td>
                      <td>—</td>
                      <td>MEMBER-SHARES</td>
                      <td>M-590399876</td>
                      <td className="text-end fw-bold text-success">$ 20.00</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                      <td>
                        <i className="fas fa-external-link-alt fs-6 text-secondary"></i>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {portfolioSubTab === "assets" && (
            <>
              {/* Member ID Filter Buttons */}
              <div className="mb-3 d-flex gap-3 flex-wrap">
                <button
                  className="btn btn-dark"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    minWidth: "60px",
                  }}
                >
                  All
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  DXM Managed Assets
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Other
                </button>
                <button
                  className="btn btn-outline-primary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    marginLeft: "auto",
                    color: "#e91e63",
                    borderColor: "#e91e63",
                  }}
                >
                  + Add new asset
                </button>
              </div>

              {/* Assets Table */}
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  hover
                  size="sm"
                  style={{ fontSize: 12, minWidth: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>
                        CATEGORY{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>PRODUCT NAME</th>
                      <th>DESCRIPTION</th>
                      <th>VALUE</th>
                      <th>
                        MANAGED BY{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>
                        <i className="fas fa-eye" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Real Estate</td>
                      <td>House</td>
                      <td>29 Sparrow Lane, New Westminster, BC...</td>
                      <td className="text-end fw-bold text-success">
                        $ 3,268,987.00
                      </td>
                      <td>Other</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Real Estate</td>
                      <td>House</td>
                      <td>1234 Merritville, Merrit, BC...</td>
                      <td className="text-end fw-bold text-success">
                        $ 899,999.00
                      </td>
                      <td>Other</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Investments</td>
                      <td>Crypto</td>
                      <td>Digital tokens</td>
                      <td className="text-end fw-bold text-success">
                        $ 120,000.00
                      </td>
                      <td>Self</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Investments</td>
                      <td>RSP</td>
                      <td>Save for life plan</td>
                      <td className="text-end fw-bold text-success">
                        $ 1,500,000.00
                      </td>
                      <td>DXM Financial</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                    <tr>
                      <td>Investments</td>
                      <td>RSP</td>
                      <td>SRI • Mutual</td>
                      <td className="text-end fw-bold text-success">
                        $ 18,290.18
                      </td>
                      <td>DXM Financial</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </>
          )}

          {portfolioSubTab === "liabilities" && (
            <>
              {/* Member ID Filter Buttons */}
              <div className="mb-3 d-flex gap-3 flex-wrap">
                <button
                  className="btn btn-dark"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    minWidth: "60px",
                  }}
                >
                  All
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  DXM Managed Assets
                </button>
                <button
                  className="btn btn-outline-secondary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    backgroundColor: "#f8f9fa",
                    border: "1px solid #dee2e6",
                    marginLeft: "1rem",
                  }}
                >
                  Other
                </button>
                <button
                  className="btn btn-outline-primary"
                  style={{
                    fontSize: "14px",
                    fontWeight: "500",
                    padding: "8px 16px",
                    marginLeft: "auto",
                    color: "#e91e63",
                    borderColor: "#e91e63",
                  }}
                >
                  + Add new liability
                </button>
              </div>

              {/* Liabilities Table */}
              <div style={{ overflowX: "auto" }}>
                <Table
                  striped
                  hover
                  size="sm"
                  style={{ fontSize: 12, minWidth: "100%" }}
                >
                  <thead>
                    <tr>
                      <th>
                        CATEGORY{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>PRODUCT NAME</th>
                      <th>DESCRIPTION</th>
                      <th>VALUE</th>
                      <th>LOAN BALANCE</th>
                      <th>
                        MANAGED BY{" "}
                        <i
                          className="fas fa-sort"
                          style={{ fontSize: "10px", marginLeft: "4px" }}
                        ></i>
                      </th>
                      <th>
                        <i className="fas fa-eye" />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Auto</td>
                      <td>SUV</td>
                      <td>2025 Mercedes G-Wagon</td>
                      <td className="text-end fw-bold text-success">
                        $ 268,987.00
                      </td>
                      <td className="text-end fw-bold text-danger">
                        $ 5,789.00
                      </td>
                      <td>Other</td>
                      <td className="text-center">
                        <i className="fas fa-eye fs-6 text-secondary"></i>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </>
          )}
        </div>
      )}

      {memberApplicationsTab === "notes" && (
        <div>
          <h6 className="fw-bold mb-3">Notes</h6>
          <div className="text-center py-4">
            <p className="text-muted">Notes section coming soon.</p>
          </div>
        </div>
      )}

      {memberApplicationsTab === "client-growth" && (
        <div>
          <h6 className="fw-bold mb-3">Client Growth Potential</h6>
          <div className="text-center py-4">
            <p className="text-muted">
              Client Growth Potential section coming soon.
            </p>
          </div>
        </div>
      )}

      {memberApplicationsTab === "applications" && (
        <div>
          {/* Header with title and marketplace button */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h5
              className="mb-0 fw-bold"
              style={{ color: "#333", fontSize: "1.1rem" }}
            >
              <i
                className="fas fa-file-alt mr-2"
                style={{ color: "#333", marginRight: "4px" }}
              ></i>
              APPLICATIONS
            </h5>
            <button
              type="button"
              className="btn"
              onClick={handleMemberMarketplace}
              style={{
                backgroundColor: "#e91e63",
                color: "white",
                border: "none",
                borderRadius: "4px",
                fontSize: "0.85rem",
                fontWeight: "600",
                padding: "8px 16px",
              }}
            >
              <i className="fas fa-shopping-cart mr-2"></i> Go to the
              Marketplace
            </button>
          </div>

          <ApplicationList
            applicationList={applicationList}
            productVault={productVault}
            productList={productList}
            proceedWithApplication={proceedWithApplication}
            switchBanking={switchBanking}
            history={history}
            targetApplicationId={targetApplicationId}
            doDeleteApplication={doDeleteApplication}
            doUpdateProductToVault={doUpdateProductToVault}
            refreshMemberDetails={refreshMemberDetails}
            doAddDocument={doAddDocument}
            doDeleteDocument={doDeleteDocument}
            doGetDocumentList={doGetDocumentList}
            doGetDocument={doGetDocument}
            doGetApplicationProperty={doGetApplicationProperty}
            selectedMember={selectedMember}
            applicant={applicant}
            employmentAndIncomeReducer={employmentAndIncomeReducer}
            complianceReducer={complianceReducer}
            doGetProductInformation={doGetProductInformation}
            finInfo={finInfo}
            doGetApplicationNotes={doGetApplicationNotes}
            doUpdateApplicationNotesReview={doUpdateApplicationNotesReview}
            doConfirmApp={doConfirmApp}
            doGetProductFromVault={doGetProductFromVault}
            doGetVault={doGetVault}
            updateUrlParams={updateUrlParams}
            setMemberApplicationsTab={setMemberApplicationsTab}
            setShowMemberDetails={setShowMemberDetails}
            handleBreadcrumbBackToApplications={
              handleBreadcrumbBackToApplications
            }
          />
        </div>
      )}
    </div>
  );
}
